/**
 * This file just exports icons that we have adopted for reuse.
 */
import {
  ArrowCircleDown,
  ArrowCircleRightOutlined,
  ArrowDropDown,
  ArrowUpwardRounded,
  AssignmentTurnedInOutlined,
  BugReport,
  BuildOutlined,
  Fullscreen,
  FullscreenExit,
  InfoOutlined,
  MoreHoriz,
  RotateLeft,
  RotateRight,
  Security,
  ZoomIn,
  ZoomOut
} from '@mui/icons-material';
import {
  Activity,
  ArrowDownFromLine,
  ArrowUpFromLine,
  BlocksIcon,
  Bot,
  Calendar,
  Check,
  ChevronDownIcon,
  ChevronUpIcon,
  CircleArrowDown,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleMinus,
  CirclePlayIcon,
  CircleQuestionMarkIcon,
  CircleStop,
  CircleX,
  CircuitBoard,
  Clock,
  ClockArrowUp,
  Copy,
  CopyPlusIcon,
  CornerLeftUpIcon,
  Earth,
  Eye,
  FileSpreadsheetIcon,
  FolderGit2Icon,
  FullscreenIcon,
  GitCommitHorizontalIcon,
  GlobeIcon,
  GripVerticalIcon,
  Hash,
  HistoryIcon,
  Hourglass,
  LayoutGrid,
  LinkIcon,
  List,
  ListChevronsDownUpIcon,
  ListChevronsUpDownIcon,
  ListPlusIcon,
  LoaderCircleIcon,
  LocateIcon,
  LockOpen,
  ArrowLeftIcon as LucideArrowLeftIcon,
  ArrowRightIcon as LucideArrowRightIcon,
  CheckIcon as LucideCheckIcon,
  ChevronLeftIcon as LucideChevronLeftIcon,
  ChevronRightIcon as LucideChevronRightIcon,
  CirclePlusIcon as LucideCirclePlusIcon,
  DownloadIcon as LucideDownloadIcon,
  FolderIcon as LucideFolderIcon,
  ImportIcon as LucideImportIcon,
  InfoIcon as LucideInfoIcon,
  MenuIcon as LucideMenuIcon,
  MoonIcon as LucideMoonIcon,
  SearchIcon as LucideSearchIcon,
  SettingsIcon as LucideSettingsIcon,
  TagIcon as LucideTagIcon,
  Minus,
  MonitorIcon,
  OctagonAlert,
  PackageIcon,
  PaletteIcon,
  PanelLeftCloseIcon,
  PanelRightCloseIcon,
  PauseCircle,
  PenLine,
  PieChartIcon,
  PlayCircle,
  PlusIcon,
  RefreshCwIcon,
  ScrollText,
  SearchCodeIcon,
  SparklesIcon,
  SquarePen,
  SunIcon,
  Trash2Icon,
  TriangleAlert,
  Undo2,
  UnfoldVertical,
  UnlinkIcon,
  UserRound,
  UsersIcon,
  XIcon
} from 'lucide-react';
import {
  GoGitBranch,
  GoGitCommit,
  GoGitMerge,
  GoGitPullRequest,
  GoGitPullRequestClosed,
  GoGitPullRequestDraft
} from 'react-icons/go';
import {
  VscCloudDownload,
  VscCollapseAll,
  VscExpandAll,
  VscGitMerge,
  VscGitPullRequest,
  VscGitPullRequestClosed,
  VscKey,
  VscRepoForked
} from 'react-icons/vsc';
import {
  ModAzureDevOpsIcon,
  ModBitbucketIcon,
  ModCheckboxCheckedIcon,
  ModCheckboxIndeterminateIcon,
  ModCheckboxUncheckedIcon,
  ModCheckedOutlineIcon,
  ModColumnsIcon,
  ModErrorIcon,
  ModFileAddedIcon,
  ModFileModifiedIcon,
  ModFileRemovedIcon,
  ModFileRenamedIcon,
  ModFilterListIcon,
  ModGitHubIcon,
  ModGitLabIcon,
  ModGraphQLIcon,
  ModKebabMenuIcon,
  ModLeftClickRotateIcon,
  ModRecommendedSortIcon,
  ModReloadIcon,
  ModRightClickPanIcon,
  ModScrollWheelIcon,
  ModShareIcon,
  ModSortAZAlphaIcon,
  ModSortZAAlphaIcon,
  ModWarningIcon
} from './moderne-icons';
// Left Navigation

export const BrowseRecipesIcon = GlobeIcon;
export const CalendarIcon = Calendar;
export const ChangelogIcon = Activity;
export const DeployRecipesIcon = PackageIcon;
export const RecentActivityIcon = HistoryIcon;
export const RepositoryIcon = FolderGit2Icon;
export const AuditLogsIcon = ScrollText;
export const ConnectorsIcon = CircuitBoard;
export const AccessTokenIcon = LockOpen;
export const UserIcon = UserRound;
export const AgentIcon = Bot;
export const TopicIcon = Hash;
export const OrganizationSourcesIcon = FileSpreadsheetIcon;
export const MenuIcon = LucideMenuIcon;
export const AdminIcon = LucideSettingsIcon;
export const DevCenterIcon = PieChartIcon;
export const ProfilingIcon = Activity;
export const AiIcon = SparklesIcon;
export const BuilderIcon = BlocksIcon;

// Org & repo
export const OrganizationIcon = UsersIcon;
export const GlobalOrganizationIcon = Earth;
// Common
export const CheckIcon = ModCheckedOutlineIcon;
export const CheckSimpleIcon = LucideCheckIcon;
export const CircleCheckBigIcon = CircleCheckBig;
export const CheckboxCheckedIcon = ModCheckboxCheckedIcon;
export const CheckboxIndeterminateIcon = ModCheckboxIndeterminateIcon;
export const CheckboxUncheckedIcon = ModCheckboxUncheckedIcon;
export const CloseIcon = XIcon;
export const CollapseAllIcon = VscCollapseAll;
export const CollapseAllIcon2 = ListChevronsUpDownIcon;
export const CollapseIcon = ChevronDownIcon;
export const ConfigureIcon = BuildOutlined;
export const CopyConfirmedIcon = AssignmentTurnedInOutlined;
export const CopyIcon = Copy;
export const DebugIcon = BugReport;
export const DeleteIcon = Trash2Icon;
export const DownloadIcon = VscCloudDownload;
export const DownloadSimpleIcon = LucideDownloadIcon;
export const DropDownArrowIcon = ArrowDropDown;
export const DuplicateIcon = CopyPlusIcon;
export const RecipeInheritedFromIcon = CornerLeftUpIcon;
export const ExpandAllIcon = VscExpandAll;
export const ExpandIcon = LucideChevronRightIcon;
export const ChevronLeftIcon = LucideChevronLeftIcon;
export const ShowLessIcon = ChevronUpIcon;
export const ShowMoreIcon = ChevronDownIcon;
export const ExpandUpIcon = ArrowUpFromLine;
export const ExpandDownIcon = ArrowDownFromLine;
export const UnfoldIcon = UnfoldVertical;
export const ExpandAllIcon2 = ListChevronsDownUpIcon;
export const GitCommitIcon = GitCommitHorizontalIcon;
export const GraphQLIcon = ModGraphQLIcon;
export const HelpIcon = CircleQuestionMarkIcon;
export const InfoIcon = LucideInfoIcon;
export const WarningIcon = ModWarningIcon;
export const ErrorIcon = ModErrorIcon;
export const PullRequestIcon = VscGitPullRequest;
export const ForkIcon = VscRepoForked;
export const SearchIcon = LucideSearchIcon;
export const CodeSearchIcon = SearchCodeIcon;
export const SettingsIcon = LucideSettingsIcon;
export const GpgKeyIcon = VscKey;
export const ArrowLeftIcon = LucideArrowLeftIcon;
export const ArrowRightIcon = LucideArrowRightIcon;
export const ArrowCircleDownIcon = ArrowCircleDown;
export const ArrowUpFilledIcon = CircleArrowUp;
export const RightArrowIcon = ArrowCircleRightOutlined;
export const OriginInfoIcon = InfoOutlined;
export const UpArrowIcon = ArrowUpwardRounded;
export const FilterListIcon = ModFilterListIcon;
export const ColumnsIcon = ModColumnsIcon;
export const KebabMenuIcon = ModKebabMenuIcon;

// User Configurations
export const BitBucketIcon = ModBitbucketIcon;
export const GitLabIcon = ModGitLabIcon;
export const GitHubIcon = ModGitHubIcon;
export const AzureDevOpsIcon = ModAzureDevOpsIcon;

// Sorting
export const RecommendedSortIcon = ModRecommendedSortIcon;
export const SortAlphabeticalIcon = ModSortAZAlphaIcon;
export const SortReverseAlphabeticalIcon = ModSortZAAlphaIcon;

// Recipe
export const AddToListIcon = ListPlusIcon;
export const ReplayIcon = ModReloadIcon;
export const RunIcon = CirclePlayIcon;
export const ShareIcon = ModShareIcon;

// Builder
export const ImportIcon = LucideImportIcon;

export const GoToOriginIcon = LocateIcon;
export const TagIcon = LucideTagIcon;
export const ColorDebuggerIcon = PaletteIcon;
export const EditIcon = SquarePen;
export const LoadCustomRecipeIcon = BlocksIcon;
export const AddNodeIcon = PlusIcon;
export const NewRecipeIcon = PlusIcon;
export const SavedRecipeIcon = CircleArrowDown;
export const RefreshIcon = RefreshCwIcon;
export const SavingRecipeIcon = RefreshCwIcon;
export const MoonIcon = LucideMoonIcon;
export const MoveTopologyToCenterIcon = PanelLeftCloseIcon;
export const MoveTopologyToSideBarIcn = PanelRightCloseIcon;
export const ScrollWheelIcon = ModScrollWheelIcon;
export const RightClickPanIcon = ModRightClickPanIcon;
export const LeftClickRotateIcon = ModLeftClickRotateIcon;
export const UndoIcon = Undo2;
export const LinkedFieldsIcon = LinkIcon;
export const UnlinkedFieldsIcon = UnlinkIcon;
export const CirclePlusIcon = LucideCirclePlusIcon;

// Runs
export const CollapseDialogIcon = FullscreenExit;
export const ExpandDialogIcon = Fullscreen;
export const MoreActionsIcon = MoreHoriz;

// Results
export const FolderIcon = LucideFolderIcon;
export const FileModifiedIcon = ModFileModifiedIcon;
export const FileAddedIcon = ModFileAddedIcon;
export const FileRemovedIcon = ModFileRemovedIcon;
export const FileRenamedIcon = ModFileRenamedIcon;
export const BlamePriorIcon = HistoryIcon;

// Commit Jobs
export const SunnyIcon = SunIcon;
export const MergeIcon = VscGitMerge;
export const ClosePullRequestIcon = VscGitPullRequestClosed;

// Server Status

// Data tables
export const CardsViewIcon = LayoutGrid;
export const ListViewIcon = List;
export const InspectIcon = Eye;

// Moderne CLI

// Update components
export const RestrictedIcon = Security;

// Visualization components
export const ZoomInIcon = ZoomIn;
export const ZoomOutIcon = ZoomOut;
export const RecenterIcon = FullscreenIcon;
export const ReverseTreeIcon = RotateLeft;
export const ResetTreeIcon = RotateRight;

export const DragHandleIcon = GripVerticalIcon;
export const StopCircleIcon = CircleStop;

// Auto-rotation
export const PlayIcon = PlayCircle;
export const PauseIcon = PauseCircle;

// CI states

// Review states

// Changelog
export const CheckmarkIcon = Check;
export const ClockIcon = Clock;
export const ClockArrowUpIcon = ClockArrowUp;
export const GoGitCommitIcon = GoGitCommit;
export const GitBranchIcon = GoGitBranch;
export const GitMergeIcon = GoGitMerge;
export const GitPullRequestIcon = GoGitPullRequest;
export const GitPullRequestClosedIcon = GoGitPullRequestClosed;
export const GitPullRequestDraftIcon = GoGitPullRequestDraft;
export const HourglassIcon = Hourglass;
export { LoaderCircleIcon, MonitorIcon, PlusIcon };
export const MinusIcon = Minus;
export const PenLineIcon = PenLine;

// Outline status glyphs for the pill status badge (Figma "Badge"); the filled
// ModFilled* set stays for non-badge contexts.
export const CircleCheckIcon = CircleCheck;
export const CircleMinusIcon = CircleMinus;
export const CircleXIcon = CircleX;
export const OctagonAlertIcon = OctagonAlert;
export const TriangleAlertIcon = TriangleAlert;
